import { Component, input, OnInit } from '@angular/core';
import { MemberModel } from '../../../../core/models/data/member.model';
import { PaymentHistoryListComponent } from '../../../balances/components/payment-history-list/payment-history-list.component';
import { PaymentHistoryListViewLocations } from '../../../../core/enums/base.enums';
import { PaymentHistoryFilter } from '../../../../core/filters/payment-history.filter';
import { ListConstants } from '../../../../core/constants/lists.constants';

@Component({
  selector: 'ms-member-payment-history',
  imports: [PaymentHistoryListComponent],
  templateUrl: './member-profile-payment-history.component.html'
})
export class MemberProfilePaymentHistoryComponent implements OnInit {
  public member = input<MemberModel | undefined>(undefined);

  // Forwarded from the profile page so the list can offer a member their own receipts.
  public isEntityOwner = input<boolean>(false);

  public PaymentHistoryListViewLocations = PaymentHistoryListViewLocations;
  public paymentHistoryFilter: PaymentHistoryFilter = ListConstants.PAYMENT_HISTORY_FILTER_DEFAULT();
  public orderBy: string = ListConstants.PAYMENT_HISTORY_ORG_VIEW_ORDERBY_DEFAULT();

  public ngOnInit(): void {
    const memberId = this.member()?.memberId;
    if (memberId != null) {
      this.paymentHistoryFilter.memberIds = [memberId];
    }
  }

  public onOrderByChanged(value: string): void {
    this.orderBy = value;
  }
}
